import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import {
  arrangeDataWeekly,
  arrangeDataMonthly,
  arrangeDataDateWise,
} from "AnalyticscommonAnalyticscommonindex";
import { usersChartWidth } from "Constants";
import LocaleStrings from "Languages";

class AttendeesnetworkEngmntBarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstload: true,
      data: [],
      hitstype: "date",
      innerLoader: props.newprop,
    };
  }

  componentDidMount() {
    // var barchartData = arrangeDataWeekly(this.props.attnnetwrkengabarchart);
    var barchartData = arrangeDataDateWise(
      this.props.attnnetwrkengabarchart,
      this.props.dateProps
    );

    this.setState({ data: barchartData });
  }

  componentWillReceiveProps(nextprops) {
    if (this.state.innerLoader != nextprops.newprop) {
      this.setState({ innerLoader: !nextprops.newprop });

      var barchartData =
        this.state.hitstype == "monthly"
          ? arrangeDataMonthly(nextprops.attnnetwrkengabarchart)
          : this.state.hitstype == "weekly"
          ? arrangeDataWeekly(nextprops.attnnetwrkengabarchart)
          : arrangeDataDateWise(
              nextprops.attnnetwrkengabarchart,
              nextprops.dateProps
            );

      this.setState({ data: barchartData });
    }
  }

  // Weekly / Monthly / Date wise [on change]
  onOptionsChange = (e) => {
    var hitstype = e.currentTarget.value;
    this.setState({ hitstype });
    if (hitstype === "weekly") {
      //Weekly

      var barchartData = arrangeDataWeekly(this.props.attnnetwrkengabarchart);
      this.setState({ data: barchartData });
    } else if (hitstype === "monthly") {
      //Monthly

      var barchartData = arrangeDataMonthly(this.props.attnnetwrkengabarchart);
      this.setState({ data: barchartData });
    } else {
      // Date wise

      var barchartData = arrangeDataDateWise(
        this.props.attnnetwrkengabarchart,
        this.props.dateProps
      );
      this.setState({ data: barchartData });
    }
  };

  render() {
    var { data, hitstype } = this.state;

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-default dashboard-panel">
            <div
              className="panel-heading dashboard-panel-head"
              style={{ minHeight: "99px" }}
            >
              <div className="pull-left chartHeaderSection">
                <p className="analytics-chart-header">
                  {
                    LocaleStrings.analytics_attendeesnetworking_table_header_text1
                  }
                </p>
                <p className="analytics-chart-subheader">
                  {
                    LocaleStrings.analytics_attendeesnetworking_table_subheader_text1
                  }
                </p>
              </div>
              <div className="pull-right text-capitalize addNewField">
                <ul className="header-buttons">
                  <li>
                    <span className="analytics-chart-right-subheader">
                      {LocaleStrings.as_per_date}
                    </span>
                    {/* <select
                      onChange={this.onOptionsChange}
                      name="hitstype"
                      className="form-control"
                    >
                      <option value="weekly">{LocaleStrings.weekly}</option>
                      <option value="monthly">{LocaleStrings.monthly}</option>
                      <option value="date">{LocaleStrings.as_per_date}</option>
                    </select> */}
                  </li>
                </ul>
              </div>
            </div>
            {data.length > 0 ? (
              <div className="panel-body">
                <BarChart
                  width={usersChartWidth - 100}
                  height={300}
                  data={data}
                  margin={{
                    top: 50,
                    right: 5,
                    left: 5,
                    bottom: 5,
                  }}
                >
                  <XAxis dataKey="name" />
                  <Tooltip />
                  <Bar dataKey="hits" fill="#4da1ff" />
                </BarChart>
              </div>
            ) : (
              <div className="nouser-info">
                <span>{LocaleStrings.analytics_text_no_hits_recorded}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    attendeesnetworkEngagementbarChart:
      state.attendeesnetworkEngagementbarChart,
    dateProps: state.analyticscommondatepropsreducer,
  };
}

export default connect(mapStateToProps)(AttendeesnetworkEngmntBarChart);
